import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Row, Col, Button, Modal, ToggleButton, ToggleButtonGroup, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addUser, getUsers, editUser, enableUser, disableUser, importTeachers, importStudents } from '../../../actions/usersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import { toastSuccess } from '../../../components/swal/toast'
import Loader from '../../../components/loaders/Loader'
import UserForm from '../../../components/forms/UserForm'

export default function Users() {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()

    const { users, resultuser, loading } = useSelector(state => state.users)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [filterActive, setFilterActive] = useState(true)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [totalRows, setTotalRows] = useState(0)

    useEffect(() => {
        if (clientauth) {
            dispatch(getUsers(page, limit, search))
        }
    }, [dispatch, t, clientauth, location, page, limit, search])

    const openModal = () => {
        setIsAddingOrEditing('adding')
        setFormState({
            username: '',
            email: '',
            password: '',
            rol: 'Secretary'
        })
        setModalShow(true)
    }

    const handleImportTeachers = () => {
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'question',
            html: t('admin.users.areyousureimportteachers')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(importTeachers())
            }
        })
    }

    const handleImportStudents = () => {
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'question',
            html: t('admin.users.areyousureimportstudents')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(importStudents())
            }
        })
    }

    const selectUser = (user) => {
        setIsAddingOrEditing('editing')
        setFormState(user)
        setModalShow(true)
    }

    const handleInputChange = ({ target }) => {
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange = ({ target }) => {
        setFormState({
            ...formState,
            [target.name]: target.checked
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsRegistering(true)

        if (isAddingOrEditing === 'editing') {
            dispatch(editUser(formState, formState._id))
        } else {
            dispatch(addUser(formState))
        }
        setIsRegistering(false)
    }

    const disableEnableUsers = async (e) => {
        e.preventDefault()
        let textQuestion = ''
        formState.active
            ?
            textQuestion = t('admin.users.areyousuredisable') + '<br><p><label className="fs-20 fw-600 pt-5">' + formState?.username + '</label></p>'
            :
            textQuestion = t('admin.users.areyousureenable') + '<br><p><label className="fs-20 fw-600 pt-5">' + formState?.username + '</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'question',
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableUser(formState._id))
                } else {
                    dispatch(enableUser(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if (resultuser) {
            let resultuserTemp = resultuser
            dispatch({ type: 'USER_RESET_RESULT' })
            switch (resultuserTemp) {
                case 'success':
                    toastSuccess(t('admin.users.addsuccess'))
                    setModalShow(false)
                    setIsAddingOrEditing(false)
                    break;
                case 'successedit':
                    toastSuccess(t('admin.users.editsuccess'))
                    setModalShow(false)
                    setIsAddingOrEditing(false)
                    break;
                case 'successenable':
                    toastSuccess(t('admin.users.enablesuccess'))
                    setModalShow(false)
                    setIsAddingOrEditing(false)
                    break;
                case 'successdisable':
                    toastSuccess(t('admin.users.disablesuccess'))
                    setModalShow(false)
                    setIsAddingOrEditing(false)
                    break;
                case 'successimportteachers':
                    toastSuccess(t('admin.users.importteachersuccess'))
                    setModalShow(false)
                    setIsAddingOrEditing(false)
                    break;
                case 'successimportstudents':
                    toastSuccess(t('admin.users.importstudentsuccess'))
                    setModalShow(false)
                    setIsAddingOrEditing(false)
                    break;
                default:
                    break;
            }
        }
        // eslint-disable-next-line
    }, [resultuser])

    const columnsUsers = [
        {
            name: t('admin.users.email'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.email}
                </div>,
            selector: (user) => user.email,
            sortable: true,
        }, {
            name: t('admin.users.username'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.name}
                </div>,
            selector: (user) => user.name,
            sortable: true,
        }, {
            name: t('admin.users.rol'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {t('admin.users.' + user.rol)}
                </div>,
            selector: (user) => user.rol,
            sortable: true,
        }, {
            name: t('admin.users.active'),
            width: '200px',
            cell: user =>
                <div>
                    {user.active
                        ?
                        <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                        <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (user) => user.active,
            sortable: true,
        }, {
            name: '',
            width: '200px',
            center: true,
            cell: user =>
                <>
                    <div className='cursor me-3' onClick={() => selectUser(user)}>
                        <i className='fas fa-pencil'></i>
                    </div>
                </>,
            sortable: false,
        }
    ]

    const filteredUsers = users?.filter(user => user.active === filterActive)

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col xs={12} className='text-center'>
                    <h1>
                        {filterActive
                            ?
                            t('admin.users.usersenabled')
                            :
                            t('admin.users.usersdisabled')
                        }
                    </h1>
                </Col>
                <Col xs={6} className='d-flex justify-content-start'>
                    <ToggleButtonGroup
                        type="radio"
                        name="filterActive"
                        value={filterActive}
                        onChange={setFilterActive}
                    >
                        <ToggleButton id="tbg-active" value={true} variant={filterActive === true ? "primary" : "outline-secondary"}>
                            {t('admin.users.enabled')}
                        </ToggleButton>
                        <ToggleButton id="tbg-inactive" value={false} variant={filterActive === false ? "primary" : "outline-secondary"}>
                            {t('admin.users.disabled')}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
                <Col xs={6} className='d-flex justify-content-end'>
                    <Button variant='primary' className='m-2 cursor' onClick={() => handleImportTeachers()}>
                        {t('admin.users.importteachers')}
                    </Button>
                    <Button variant='primary' className='m-2 cursor' onClick={() => handleImportStudents()}>
                        {t('admin.users.importstudents')}
                    </Button>
                    <Button variant='primary' type="submit" className="m-2 cursor" onClick={() => openModal()}>
                        {t('admin.users.createuser')}
                    </Button>
                </Col>
            </Row>
            {loading ?
                <Loader />
                :
                <Row>
                    <Col>
                        <div className="d-flex my-2">
                            <input
                                type="text"
                                className="form-control me-2"
                                placeholder={t("datatables.buscar")}
                                value={searchAux || ""}
                                onChange={e => {
                                    setSearchAux(e.target.value);
                                    setPage(1);
                                }}
                                onKeyDown={(e) => { if (e.key === 'Enter') { setSearch(searchAux); setPage(1); } }}
                            />
                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                        </div>
                        {loading ?
                            <div className="d-flex justify-content-center">
                                <Spinner animation="border" variant="primary" />
                            </div>
                            :
                            filteredUsers?.length > 0 ?
                                <CustomDataTable
                                    columns={columnsUsers}
                                    data={filteredUsers}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    exportable={false}
                                    printable={false}
                                    searchable={'custom'}
                                    searchText={search}
                                    onChangeRowsPerPage={(newLimit) => {
                                        setLimit(newLimit)
                                        setPage(1)
                                    }}
                                    onChangePage={(newPage) => {
                                        setPage(newPage)
                                    }}
                                />
                                :
                                <h4 className='mt-4'>{t('admin.users.thereisnotusers')}</h4>
                        }
                    </Col>
                </Row>
            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.users.users')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleCheckboxChange={handleCheckboxChange}
                        submit={handleSubmit}
                        disableEnableUsers={disableEnableUsers}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}